module.exports = __webpack_public_path__ + "static/media/cullen_ashes.05a9a58a.png";